var _title, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPhotoAdded = function SvgPhotoAdded(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    "data-name": "Layer 5",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "photo-added")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.55,30A4,4,0,0,1,22,28a4,4,0,0,1,4-4h2V22a4,4,0,0,1,4-4,4,4,0,0,1,2,.55V12a4,4,0,0,0-4-4H22L20,4H12L10,8H4a4,4,0,0,0-4,4V26a4,4,0,0,0,4,4ZM26,12h4v2H26ZM16,12a6,6,0,1,1-6,6A6,6,0,0,1,16,12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38,26H34V22a2,2,0,0,0-4,0v4H26a2,2,0,0,0,0,4h4v4a2,2,0,0,0,4,0V30h4a2,2,0,0,0,0-4Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhotoAdded, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/photo-added.a2c99109.svg";
export { ForwardRef as ReactComponent };